import { env } from '@/env.mjs';

export const categoryPath =
    env.NEXT_PUBLIC_APP_COUNTRY === 'RO' ? 'categorii' : 'kategorie';

export const getCategory = () =>
    window?.location?.pathname
        .split(`/${categoryPath}/`)
        .pop()
        ?.split('/')
        .shift();
